import { useState } from "react"
import { useInterval } from "../utils/useInterval"

export const useCountDown = ({
    getLastSendTime,
    setLastSendTime,
    durationInSec,
}) => {
    const [countdown, setCountdown] = useState(0)

    useInterval(
        () => setCountdown((prev) => prev - 1),
        countdown > 0 ? 1000 : null
    )

    const getRemainingTime = async () => {
        const lastSendTime = await getLastSendTime?.()
        if (!lastSendTime) return 0

        const lastSendDate = new Date(lastSendTime)
        const now = new Date()
        const elapsedSeconds = Math.floor((now - lastSendDate) / 1000)
        const remainingSeconds = Math.max(0, durationInSec - elapsedSeconds)

        return remainingSeconds
    }

    const initializeCountdown = async () => {
        const remainingTime = await getRemainingTime()
        if (!remainingTime) {
            const now = new Date().toISOString()
            await setLastSendTime?.(now)
            setCountdown(durationInSec)
        } else {
            setCountdown(remainingTime)
        }
    }

    return { countdown, initializeCountdown }
}
